import type { Product } from '@@partner:types:app'

import React, { useState } from 'react'
import { useDebounce } from 'use-debounce'

import NoPreviewProductUploader from '@components/utils/manageProduct/NoPreviewProductUploader'
import ProductWithoutPreviewFilter, { DEFAULT_PRODUCT_WITHOUT_PREVIEW_FILTER } from '@components/utils/manageProduct/ProductWithoutPreviewFilter'
import { Panel } from 'rsuite'

export default function ManageNoPhotoProducts () {
  const [ filter, setFilter ] = useState(DEFAULT_PRODUCT_WITHOUT_PREVIEW_FILTER)

  const [ debouncedFilter ] = useDebounce(filter, 500)

  const handleUpdateFilter = (field: string, value: any) => {
    setFilter(filter => ({ ...filter, [field]: value }))
  }

  const handleResetFilter = () => {
    setFilter(DEFAULT_PRODUCT_WITHOUT_PREVIEW_FILTER)
  }

  const handleSkipClick = (product: Product) => {
    handleUpdateFilter('afterId', product.id)
  }

  const handleSuccessUpload = (product: Product) => {
    handleUpdateFilter('afterId', product.id)
  }

  return <div className="my-2 mx-4">
    <Panel header="Фильтры" bordered shaded>
      <ProductWithoutPreviewFilter
        filter={ filter }
        onUpdateFilter={ handleUpdateFilter }
        onResetFilterClick={ handleResetFilter }
      />
    </Panel>

    <Panel>
      <NoPreviewProductUploader
        filter={ debouncedFilter }
        onResetFilter={ handleResetFilter }
        onSkipProduct={ handleSkipClick }
        onSuccessUpload={ handleSuccessUpload }
      />
    </Panel>
  </div>
}